module.exports = __webpack_public_path__ + "static/media/live12_07_2022.bf2d13da.jpeg";